import React from 'react';
import {useTranslation} from 'react-i18next';
import styles from './TitleWrapper.module.scss';

interface TitleProps {
    title: string;
    subtitle?: string;
}

const TitleWrapper = ({title, subtitle}: TitleProps) => {
    const {t, i18n} = useTranslation();
    return (
        <div className={styles.heading_wrapper}>
            <div className={styles.title}>{title}</div>
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
    );
};

export default TitleWrapper;
